import { render, staticRenderFns } from "./DataBuildSelectColumnsImportContactToCampaign.vue?vue&type=template&id=156bf4f1&scoped=true"
import script from "./DataBuildSelectColumnsImportContactToCampaign.vue?vue&type=script&lang=js"
export * from "./DataBuildSelectColumnsImportContactToCampaign.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DataBuildSelectColumnsImportContactToCampaign.vue?vue&type=style&index=1&id=156bf4f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156bf4f1",
  null
  
)

export default component.exports